export default __webpack_public_path__ + "static/cover-dc0c754a815f12d31c26659ae86a3243.jpg";